<mat-accordion class="search-accordion">
  <mat-expansion-panel #billingDoneFilterExpansionPanel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ 'label.search' | translate }}
      </mat-panel-title>
      <mat-panel-description style="justify-content: flex-end;">
        {{ filterLabel }}
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div>
      <form [formGroup]="billingDoneGridFilterForm" style="display: flex; flex-wrap: wrap;">

        <div class="content-row">
          <label class="content-row-label">{{ 'label.billing-type' | translate}}</label>
          <mat-select formControlName="billingType" class="content-row-input">
            <mat-option value="0">{{ 'label.all' | translate }}</mat-option>
            <mat-option value="1">{{ 'label.billing-type-1' | translate }}</mat-option>
            <mat-option value="2">{{ 'label.billing-type-2' | translate }}</mat-option>
            <mat-option value="3">{{ 'label.billing-type-3' | translate }}</mat-option>
            <mat-option value="4">{{ 'label.billing-type-4' | translate }}</mat-option>
            <mat-option value="5">{{ 'label.billing-type-5' | translate }}</mat-option>
          </mat-select>
        </div>

        <div class="content-row">
          <label class="content-row-label">{{ 'label.year' | translate}}</label>
          <mat-form-field class="content-row-input">
            <input matInput type="number" formControlName="year">
          </mat-form-field>
        </div>

        <div class="content-row">
          <label class="content-row-label">{{ 'label.month' | translate}}</label>
          <mat-select formControlName="month" class="content-row-input" multiple>
            <mat-option value="1">{{ 'label.month-1' | translate }}</mat-option>
            <mat-option value="2">{{ 'label.month-2' | translate }}</mat-option>
            <mat-option value="3">{{ 'label.month-3' | translate }}</mat-option>
            <mat-option value="4">{{ 'label.month-4' | translate }}</mat-option>
            <mat-option value="5">{{ 'label.month-5' | translate }}</mat-option>
            <mat-option value="6">{{ 'label.month-6' | translate }}</mat-option>
            <mat-option value="7">{{ 'label.month-7' | translate }}</mat-option>
            <mat-option value="8">{{ 'label.month-8' | translate }}</mat-option>
            <mat-option value="9">{{ 'label.month-9' | translate }}</mat-option>
            <mat-option value="10">{{ 'label.month-10' | translate }}</mat-option>
            <mat-option value="11">{{ 'label.month-11' | translate }}</mat-option>
            <mat-option value="12">{{ 'label.month-12' | translate }}</mat-option>
          </mat-select>
        </div>

        <div class="content-row">
          <label class="content-row-label">{{ 'label.reference' | translate}}</label>
          <mat-form-field class="content-row-input">
            <input matInput type="text" formControlName="reference">
          </mat-form-field>
        </div>

        <div class="content-row">
          <label class="content-row-label">{{ 'label.site' | translate}}</label>
          <app-site-list [control]="$any(billingDoneGridFilterForm).controls['site']" class="content-row-input"
            [pacoOnly]="true">
          </app-site-list>
        </div>
        <div class="content-row">
          <label class="content-row-label">{{ 'label.company' | translate}}</label>
          <app-company-list [control]="$any(billingDoneGridFilterForm).controls['company']" class="content-row-input">
          </app-company-list>
        </div>

        <div class="content-row">
          <label class="content-row-label">{{ 'label.is-exeptionnal-convoy' | translate}}</label>
          <mat-select formControlName="isExceptional" class="content-row-input">
            <mat-option value="">Tous</mat-option>
            <mat-option value="true">{{ 'button.yes' | translate }}</mat-option>
            <mat-option value="false">{{ 'button.no' | translate }}</mat-option>
          </mat-select>
        </div>


        <div style="display: flex;
        padding: 0px 20px;
        justify-content: flex-end;
        width: 100%;">
          <button mat-raised-button color="primary" (click)="onClearFilter()" style="margin-right: 10px;">
            <mat-icon>clear</mat-icon>
            {{ 'button.clear-filter' | translate }}
          </button>
          <button mat-raised-button color="primary" (click)="onFilter()">
            <mat-icon>search</mat-icon>
            {{ 'button.search' | translate }}
          </button>

        </div>

      </form>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<div style="width: 100%; max-height: calc(100% - 270px); overflow: auto;">

<table mat-table [dataSource]="dataSource" matSort style="width: 100%; margin-top: 5px;">

   <!-- Checkbox Column -->
   <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()">
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let row">
      <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
        [checked]="selection.isSelected(row)">
      </mat-checkbox>
    </td>
  </ng-container>
  
  <!-- year Column -->
  <ng-container matColumnDef="year">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.year' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element?.year }}</span>
    </td>
  </ng-container>

  <!-- month Column -->
  <ng-container matColumnDef="month">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.month' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span *ngIf="!(element?.billingType == BillingType.Concession)"> {{ ('label.month-' + element?.month) | translate}}</span>
      <span *ngIf="element?.billingType == BillingType.Concession"> {{ ('label.quarter-' + element?.quarter) | translate}}</span>
    </td>
  </ng-container>

  <!-- reference Column -->
  <ng-container matColumnDef="reference">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.reference' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element?.reference }}</span>
    </td>
  </ng-container>

  <!-- site Column -->
  <ng-container matColumnDef="site">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.site' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element?.site?.name }}</span>
    </td>
  </ng-container>

  <!-- company Column -->
  <ng-container matColumnDef="company">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.company' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element?.company?.name }}</span>
    </td>
  </ng-container>

  <!-- deadlineDate Column -->
  <ng-container matColumnDef="deadlineDate">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.deadlineDate' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.deadlineDate | date : 'dd/MM/yy'}}</span>
    </td>
  </ng-container>

  <!-- sendDate Column -->
  <ng-container matColumnDef="sendDate">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.sendDate' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.sendDate | date : 'dd/MM/yy HH:mm'}}</span>
    </td>
  </ng-container>

  <!-- paymentDate Column -->
  <ng-container matColumnDef="paymentDate">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.paymentDate' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.paymentDate | date : 'dd/MM/yy'}}</span>
    </td>
  </ng-container>

  <!-- reminderDate Column -->
  <ng-container matColumnDef="reminderDate">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.reminderDate' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.reminderDate | date : 'dd/MM/yy'}}</span>
    </td>
  </ng-container>

  <!-- tva Column -->
  <ng-container matColumnDef="tva">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.tva' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element?.tva }} %</span>
    </td>
  </ng-container>

  <!-- totalHtva Column -->
  <ng-container matColumnDef="totalHtva">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.totalHtva' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element?.totalHtva | number :'0.2' :'fr' }} €</span>
    </td>
  </ng-container>

  <!-- totalTva Column -->
  <ng-container matColumnDef="totalTva">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.totalTva' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element?.totalTva | number :'0.2' :'fr' }} €</span>
    </td>
  </ng-container>

  <!-- totalTtc Column -->
  <ng-container matColumnDef="totalTtc">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.totalTtc' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element?.totalTtc | number :'0.2' :'fr' }} €</span>
    </td>
  </ng-container>

  <!-- billingType Column -->
  <ng-container matColumnDef="billingType">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.billing-type' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ ('label.billing-type-' + element.billingType ) | translate }}</span>
    </td>
  </ng-container>

  <!-- isExceptional Column -->
  <ng-container matColumnDef="isExceptional">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.is-exeptionnal-convoy' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ (element.isExceptional ? 'button.yes' : 'button.no' )| translate }}</span>
    </td>
  </ng-container>

  <!-- isValide Column -->
  <ng-container matColumnDef="isValide">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.is-valide' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <mat-icon *ngIf="element.isValide" style="color:green">check</mat-icon>
    </td>
  </ng-container>


  <!-- action Column -->
  <ng-container matColumnDef="action">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header> </div>
    </th>
    <td mat-cell *matCellDef="let element">


      <button #menuActionButton mat-mini-fab color="primary" type="button" [matMenuTriggerFor]="menuAction" (click)="$event.stopPropagation();">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menuAction>
        <button mat-menu-item (click)="onValideBilling(element)" *ngIf="!element.isValide">
          <mat-icon>check</mat-icon>{{ 'billing.approuve-billing' | translate }}
        </button>
        <button mat-menu-item (click)="onCancelBilling(element)" *ngIf="!element.isValide" color="warn">
          <mat-icon color="warn">delete</mat-icon>{{ 'billing.cancel-billing' | translate }}
        </button>
        <button *ngIf="element.docId" mat-menu-item (click)="onDownload(element)">
          <mat-icon>move_to_inbox</mat-icon>{{ 'button.download-billing' | translate }}
        </button>
        <button *ngIf="!element.docId" mat-menu-item disabled>
          <mat-icon>move_to_inbox</mat-icon>{{ 'button.download-billing' | translate }}
        </button>
        <button mat-menu-item (click)="onSendMail(element)">
          <mat-icon>email</mat-icon>{{ 'billing.send-billing' | translate }}
        </button>
      </mat-menu>

      <!-- 
      <button mat-raised-button color="primary" (click)="onCancelBilling(element)">
        <mat-icon>file_copy</mat-icon>
        onCancelBilling
      </button>

      <button mat-raised-button color="primary" (click)="onValideBilling(element)">
        <mat-icon>file_copy</mat-icon>
        onValideBilling
      </button>

      <button mat-raised-button color="primary" (click)="onSendMail(element)">
        <mat-icon>file_copy</mat-icon>
        onSendMail
      </button>

      <ng-container *ngIf="element.docId; else noDocId">
        <button mat-raised-button color="primary" (click)="onDownload(element)">
          <mat-icon>file_copy</mat-icon>
          {{ 'button.download-billing' | translate }}
        </button>
      </ng-container>
      <ng-template #noDocId>
        <button mat-raised-button color="primary" disabled>
          <mat-icon>file_copy</mat-icon>
          {{ 'button.download-billing' | translate }}
        </button>
      </ng-template> -->

    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'highlight': selectedRowID == row.id}"
    (click)="selection.toggle(row)"></tr>
</table>
</div>
<mat-paginator class="m-5 mat-elevation-z2" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons>
</mat-paginator>

<div style="display: flex;justify-content: flex-end;">
  <button mat-raised-button color="primary" [disabled]="selection.isEmpty()" (click)="onValideSelectedBilling()"
    style="margin-top: 20px; margin-right: 20px;">
    <mat-icon>check</mat-icon> {{ 'billing.approuve-selected-billing' | translate }}
  </button>
  <button mat-raised-button color="primary" [disabled]="selection.isEmpty()" (click)="onSendSelectedMail()"
    style="margin-top: 20px; margin-right: 20px;">
    <mat-icon>move_to_inbox</mat-icon> {{ 'billing.send-selected-billing' | translate }}
  </button>
</div>